module.exports = __webpack_public_path__ + "static/img/pic-0.3bea15da.png";